import React from 'react';
import { Link } from 'react-router-dom';

interface FloatingActionButtonProps {
  to: string;
  icon: string;
  label?: string;
  onClick?: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ 
  to, 
  icon, 
  label,
  onClick 
}) => {
  const buttonClass = "fixed bottom-20 right-4 w-14 h-14 bg-primary text-white rounded-full shadow-lg flex items-center justify-center hover:bg-primary/90 transition-all duration-200 z-40 lg:hidden";
  
  if (onClick) {
    return (
      <button
        className={buttonClass}
        onClick={onClick}
        title={label}
      >
        <i className={`ki-filled ${icon} text-xl`}></i>
      </button>
    );
  }

  return (
    <Link
      to={to}
      className={buttonClass}
      title={label}
    >
      <i className={`ki-filled ${icon} text-xl`}></i>
    </Link>
  );
};

export default FloatingActionButton;